


class MenuDetailHeader extends MUIView
{    
    private nameLabel:MUILabel = null;    

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "section-header-name-lbl", "MUILabel");

        this.separatorStyle = UITableViewCellSeparatorStyle.None;
    }

    set item(i:ProductMenu) {
        this.nameLabel.text = i.menuCategory.name;
    } 

}